<template>
    <div class="header">
        <div class="header__page">
            <div class="header__page-button" :class="asideCollapseButton ? 'open' : ''" @click="clickAsideCollapseButton()">
                <div class="header__page-button__main"></div>
            </div>
            <div class="header__page-logo">
                <i class="header__page-logo-image"></i>
                <span class="header__page-logo-text">停車場整合管理系統</span>
            </div>
        </div>
        <div class="header__user">
            <el-dropdown trigger="click">
                <span class="el-dropdown-link">
                    {{userName}}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item>
                        <router-link :to="`${root}/resetNickname`">更改暱稱</router-link>
                    </el-dropdown-item>
                    <el-dropdown-item>
                        <router-link :to="`${root}/resetPassword`">更改密碼</router-link>
                    </el-dropdown-item>
                    <el-dropdown-item>
                        <button type="button" @click="toLogout()">登出</button>
                    </el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div>
    </div>
</template>
<script>
import * as api from "@/script/apiService/api.js"
export default {
    name: "pacaHeader",
    data(){
        return{
           root: process.env.VUE_APP_PACACLOUND_ROOT
        }
    },
    methods: {
        async toLogout(){
            await api.postLogout();
        },
        clickAsideCollapseButton: function(){
            this.$store.commit({
                type: 'setAsideCollapseButton',
                isOpen: !this.$store.state.asideCollapseButton
            })
        },
    },
    computed: {
        asideCollapseButton: function(){
            return this.$store.state.asideCollapseButton
        },
        userName(){
            return this.$store.state.userInfo ? this.$store.state.userInfo.nickname : ''
        },
        breadcrumb(){
            return this.$route.path.split("/").slice(3)
        }
    }
}
</script>